<template>
  <div>
    <div class="row head">
        <div class="col col-100">Geblokkeerde Nummers</div>
    </div>
    <div class="blacklist">
        <div class="row row-list-item setting" v-for="blacklistedNumber in blacklistedNumbers" :key="blacklistedNumber.id">
            <div class="col col-100">{{!blacklistedNumber.startsWith('0') ? '+' + blacklistedNumber : blacklistedNumber}} <span class="icon" @click="removeBlackListNumber(blacklistedNumber)"><delete-icon /></span></div>
        </div>
    </div>
    
    <div v-if="blacklistedNumbers.length <= maxBlacklistNumbers" class="new-number row finance row-list-item setting">

    <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.newBlacklistNumber.$error }">
        <input v-on:keyup.enter="addBlacklistNumber" v-model="newBlacklistNumber" type="text" @input="$v.newBlacklistNumber.$touch()"/>
    </div>
    <div v-if="$root.app.platform == 'ios'" class="col col-100" v-bind:class="{ 'validation-error': $v.newBlacklistNumber.$error }">
        <input v-on:keyup.enter="addBlacklistNumber" v-model="newBlacklistNumber" type="text" placeholder="Nieuw nummer..." @input="$v.newBlacklistNumber.$touch()"/>
    </div>
    </div>

    <div class="row spacer">&nbsp;</div>

    <div v-if="blacklistedNumbers.length <= maxBlacklistNumbers">

        <div class="row blacklist row-button">
            <div class="col col-100">
                <button @click="addBlacklistNumber" class="button dub-button dub-button-space">Voeg toe</button>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import {helpers, required, minLength, maxLength, numeric } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            newBlacklistNumber: '',
            removeBlacklistNumber: '',
            blacklistedNumbers: [],
            selectedNumbers: [],
            maxBlacklistNumbers: 200,
        }
    },
    validations: {
        newBlacklistNumber: {
            required,
            numeric,
            minLength: minLength(7),
            maxLength: maxLength(16),
        }
    },

    methods: {
        // selectNumber(number) {
        //     const id = this.selectedNumbers.indexOf(number)
        //     if(id == -1) {
        //         this.selectedNumbers.push(number)
        //         return
        //     }
        //     const removedNumber = this.selectedNumbers.splice(id, 1)
        //     console.log(removedNumber)
        // },

        getBlacklistNumbers() {
            this.$api.post('/blacklist', {
                userPoc: this.$root.user.poc,
            })
            .then(response => {
                console.log(response);
                this.blacklistedNumbers = response.data.numbers;
            })
            .catch(e => {


            })
        },

        addBlacklistNumber() {
            this.newBlacklistNumber = this.newBlacklistNumber.replace('+', '');
            console.log(this.newBlacklistNumber);
            if(this.$v.$invalid) {
                this.$root.ui.showDialog(
                    'Fout',
                    'Het ingevulde nummer is niet correct<br/>',
                    true
                );
                return;
            }

            var root = this.$root;
            var _this = this;
            var numberAdd;
            this.newBlacklistNumber.startsWith('0') ? numberAdd = '' : numberAdd = '+';

            _this.$root.ui.showDialog(
            'Blokkades',
            'Wil je het volgende nummer toevoegen aan je geblokkeerde nummers?<br><br>' +
            numberAdd + this.newBlacklistNumber,

            false,
            {
                0:{
                    name: 'Voeg toe',
                    execute: function(){
                        root.loading = true;
                        _this.$api.post('/blacklist/add', {
                            test: 'hello',
                            blacklistNumber: _this.newBlacklistNumber,
                            userPoc: _this.$root.user.poc,

                        })
                        .then(response => {
                            console.log(response);
                            _this.blacklistedNumbers = response.data.numbers;
                            _this.newBlacklistNumber = '';
                            _this.getBlacklistNumbers();
                            root.loading = false;
                            _this.$root.ui.showDialog(
                                'Voltooid',
                                'Het nummer is toegevoegd aan de bloklijst.',
                                true
                            );
                        })
                        .catch(e => {
                            root.loading = false;

                            _this.$root.ui.showDialog(
                                'Fout',
                                e,
                                true
                            );
                        })
                    }
                },
                1:{
                    name: 'Annuleren',
                    execute: function(){}
                }
            }
            );
        },

        removeBlackListNumber(number) {
            var root = this.$root;
            var _this = this;
            var numberAdd;
            number.startsWith('0') ? numberAdd = '' : numberAdd = '+';

            _this.$root.ui.showDialog(
            'Blokkades',
            'Wil je het volgende nummer verwijderen uit je geblokkeerde nummers?<br><br>' +
            numberAdd + number,

            false,
            {
                0:{
                    name: 'Verwijder',
                    execute: function(){
                        root.loading = true;

                        _this.$api.post('/blacklist/remove', {
                            userPoc: _this.$root.user.poc,
                            blacklistNumber: number,
                        })
                        .then(response => {
                            _this.blacklistedNumbers = response.data.numbers;
                            _this.newBlacklistNumber = '';
                            _this.getBlacklistNumbers();
                            root.loading = false;
                            _this.$root.ui.showDialog(
                                'Voltooid',
                                'Het nummer is verwijdert uit de bloklijst.',
                                true
                            );
                        })
                        .catch(e => {
                            root.loading = false;

                            _this.$root.ui.showDialog(
                                'Fout',
                                e,
                                true
                            );
                        })
                    }
                },
                1:{
                    name: 'Annuleren',
                    execute: function(){}
                }
            }
            );
        }
    },

    mounted() {
        this.getBlacklistNumbers();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Blacklist.vue